import {InvestorPhone} from '@/types/client-info';

export const mapClientPhone = (phone?: InvestorPhone): string | null => {
  if (!phone) {
    return null;
  }

  const {areaCode, number: phoneNumber} = phone;

  if (!areaCode || !phoneNumber) {
    return null;
  }

  return `${areaCode}${phoneNumber}`;
};
